(() => {
  const trigger = document.querySelector('[data-anu-accessibility]')
  if (!trigger) return
  let pending
  const load = () => {
    if (document.querySelector('.asw-menu-btn')) return Promise.resolve()
    if (pending) return pending
    pending = new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = trigger.dataset.widgetSrc
      script.async = true
      script.dataset.aswOffset = '20,20'
      script.onload = async () => {
        try {
          await Promise.resolve(window.SiennaPlugin)
          if (!document.querySelector('.asw-menu-btn')) throw new Error('widget_unavailable')
          resolve()
        } catch (error) { reject(error) }
      }
      script.onerror = () => { script.remove(); reject(new Error('widget_unavailable')) }
      document.body.append(script)
    }).then(() => { trigger.hidden = true }).catch(error => { pending = null; throw error })
    return pending
  }
  trigger.addEventListener('click', async () => {
    trigger.disabled = true
    trigger.setAttribute('aria-busy', 'true')
    const status = document.querySelector('[data-anu-accessibility-status]')
    status.textContent = trigger.dataset.loading
    try {
      await load()
      document.querySelector('.asw-menu-btn')?.click()
      status.textContent = ''
    } catch {
      status.textContent = trigger.dataset.error
    } finally {
      trigger.disabled = false
      trigger.removeAttribute('aria-busy')
    }
  })
  // Load only when requested. Do not clear or rewrite stored widget preferences;
  // the vendor restores them when the visitor opens the widget.
})()
